'use client';

import React, { Suspense } from 'react';
import dynamic from 'next/dynamic';
import { LoginButtonsBlock } from './components/LoginButtonsBlock';
import { useAuthBoot } from './context/AuthBootContext';
import { useLoginDisplay } from './hooks/useLoginDisplay';

const WebviewWrapper = dynamic(
  () => import('./components/WebviewWrapper').then((module) => module.WebviewWrapper),
  { ssr: false }
);

function LoginContent(): React.ReactElement {
  const { authBoot } = useAuthBoot();
  const { displayWebviewEscapeScreen } = useLoginDisplay();

  return (
    <React.Fragment>
      {displayWebviewEscapeScreen && <WebviewWrapper authBoot={authBoot} />}
      <LoginButtonsBlock />
    </React.Fragment>
  );
}

export default function Login(): React.ReactElement {
  return (
    <Suspense fallback={null}>
      <LoginContent />
    </Suspense>
  );
}
